/**
 * The custom request headers the portals exchange with the middleware.
 *
 * Values match the wire contract exactly — they are read by NestJS `@Headers()` params and written
 * by the Angular interceptors, so the two sides share one declaration rather than repeating the
 * literal and drifting on a rename.
 */
export enum IrdHeader {
  /** The portal session token; the middleware hands it on to refresh the user's permissions. */
  X_AUTH_TOKEN = 'x-auth-token',
  /** Region the client belongs to; the middleware falls back to its deployment region without it. */
  X_REGION_CODE = 'x-region-code',
  /** Retargets a single request at another portal. Ignored outright in production. */
  X_DEV_WEBSITE_URL = 'x-dev-website-url',
}
